import { FragmentState } from './interfaces';
import Debug from '../../util/Debug';
class FragmentStateManager {
    constructor(tenantId) {
        this.tenantId = tenantId;
        this.fragmentStates = new Map();
        this.traceStartTime = 0;
        this.fragmentStateChangeObservers = new Set();
        this.subscribe = (observer) => {
            this.fragmentStateChangeObservers.add(observer);
        };
        this.unsubscribe = (observer) => {
            this.fragmentStateChangeObservers.delete(observer);
        };
        this.clearAllSubscribers = () => {
            this.fragmentStateChangeObservers.clear();
        };
        this.initialize = (startTime) => {
            this.traceStartTime = startTime;
            this.fragmentStateChangeObservers.forEach((observer) => {
                observer.initialize(this.traceStartTime, this.tenantId);
            });
        };
        this.terminate = () => {
            this.fragmentStateChangeObservers.forEach((observer) => observer.terminate());
        };
        this.notifyStateChange = (fragmentName, fragmentState, customMetadata) => {
            const currentState = this.fragmentStates.get(fragmentName);
            if (currentState === undefined || currentState < fragmentState) {
                this.setFragmentState(fragmentName, fragmentState, customMetadata);
            }
            else {
                Debug.warn('[FragmentStateManager] notifyStateChange NOOP', ` because the current state(${FragmentState[currentState]})`, ` is larger than the given state(${FragmentState[fragmentState]})`);
            }
        };
        this.setFragmentState = (fragmentName, fragmentState, customMetadata) => {
            this.fragmentStates.set(fragmentName, fragmentState);
            if (fragmentState === FragmentState.Undefined)
                return;
            this.fragmentStateChangeObservers.forEach((observer) => {
                observer.stateChanged({
                    fragmentName,
                    fragmentState,
                    fragmentStateMap: this.fragmentStates,
                    customMetadata,
                });
            });
        };
    }
}
export default FragmentStateManager;
//# sourceMappingURL=FragmentStateManager.js.map